<template>
  <ion-page>
    <div class="overlay">
      <div class="match-background">
        <img :src="nationalId === 18 ? 'https://as2.ftcdn.net/v2/jpg/03/77/56/69/1000_F_377566983_efg0vCv9TJ3R38Snt2Hw727sLeZ0F9wk.jpg' : require('@/assets/images/pitch-background.jpg')" alt="Pitch Background">
      </div>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="goBack" shape="round">
            <ion-icon :icon="arrowBackOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-buttons slot="primary">
          <ion-button
            v-if="match.status === 'final' && [8,12].includes(nationalId)"
            @click="getMatchReport"
            class="report-download-btn"
            fill="solid"
            color="success"
            size="default">
            <ion-icon :icon="documentTextOutline" slot="start"></ion-icon>
            <ion-label>Report</ion-label>
          </ion-button>
          <!-- <ion-button v-if="[13].includes(nationalId)" @click="downloadMemberList">
            <ion-icon :icon="documentTextOutline"></ion-icon>
          </ion-button> -->
          <!-- <ion-button @click="setActionSheetOpen(true)">
            <ion-icon :icon="ellipsisVertical"></ion-icon>
          </ion-button> -->
        </ion-buttons>
        <ion-title class="notranslate">{{ match.competition.name }}</ion-title>
      </ion-toolbar>
      <ion-card class="custom-card">
        <div>
          <ion-card-content>
            <div class="flex justify-center normal-text notranslate">
              {{get(match, 'matchName', '')}}
            </div>
            <div class="flex justify-center normal-text" v-if="get(match, 'pool.name')">
              {{get(match, 'pool.name', '')}}
            </div>
            <!-- <div class="flex justify-center normal-text">
              {{get(match, 'venue.name', 'Venue TBA')}}
            </div>
            <div class="flex justify-center normal-text">
              {{fieldDisplayName(get(match, 'meta.field'))}}
            </div> -->
            <!-- <div class="flex justify-center light-text">{{ getMatchDate(match) }}</div> -->
            <ion-grid>
              <ion-row class="match-detail-row">
                <ion-col size="4" class="flex flex-column align-center">
                  <TeamLogo :team="get(match, 'homeTeam')" :opacity="true" v-if="!matchIsVs(match)" :competitionId="match.competition" />
                  <TeamLogoVs :team="get(match, 'homeTeam')" v-if="matchIsVs(match)" />
                  <div class="light-text text-center mt-10 team-name notranslate">{{get(match, 'homeTeam.name', get(match, 'meta.isBye') === true ? 'BYE' : 'TBA' )}}</div>
                  <p class="text-center mt-05" v-if="liveTiming && competitionTimeouts > 0">Timeouts Remaining: {{timeoutsRemainingHome}}</p>
                </ion-col>
                <!-- <ion-col v-if="get(match, 'status') === 'pre-game'" size="4" class="flex justify-around mt-30">
                  <div class="score-text">vs</div>
                </ion-col> -->
                <ion-col size="4" class="flex flex-column align-center mt-05" :key="key">
                  <ion-row class="">
                    <ion-row v-if="get(match, 'setScores', []).length && get(match, 'status') !== 'final'">
                      <div class="score-text">{{ currentSetScores }} </div>
                    </ion-row>
                    <ion-row v-if="get(match, 'setScores', []).length && get(match, 'status') === 'final'">
                      <div class="score-text">{{ setScoreTotal.home }}-{{ setScoreTotal.away }}</div>
                    </ion-row>
                    <ion-row class="mb-1" v-if="!perPeriodScoreData.display && !get(match, 'setScores', []).length">
                      <div class="score-text">{{ getScore('homeTeam') }}-{{ getScore('awayTeam') }}</div>
                    </ion-row>
                  </ion-row>
                  <ion-row class="mt-2 mb-1 per-period-section">
                    <PerPeriodScore v-if="perPeriodScoreData && perPeriodScoreData.display && !match.currentSetId" :headers="perPeriodScoreData.headers" :rows="perPeriodScoreData.rows" />
                    <PerPeriodScore v-if="perSetScoreData && match.currentSetId" :headers="perSetScoreData.headers" :rows="perSetScoreData.rows" />
                  </ion-row>
                  <div class="penalty-rows flex gap-05" v-if="match.status === 'penalty'">
                    <div class="d-grid">
                      <h3 class="text-center">Home</h3>
                      <div class="pen-column">
                        <div v-for="penTaken in penalties.filter(pen => pen.isHomeTeam)" :key="penTaken._id" :class="{'penalty': true, 'won': penTaken.value > 0, 'loss': penTaken.value === 0 }"></div>
                      </div>
                    </div>
                    <div class="d-grid">
                      <h3 class="text-center">Away</h3>
                      <div class="pen-column">
                        <div v-for="penTaken in penalties.filter(pen => !pen.isHomeTeam)" :key="penTaken._id" :class="{'penalty': true, 'won': penTaken.value > 0, 'loss': penTaken.value === 0 }"></div>
                      </div>
                    </div>
                  </div>
                <ion-badge
                :color="gameStatusColor"
                class="in-progress-box badgeQuarter">
                  <div class="timer">
                    <div class="dot timerDot" v-if="showTime(this.gameStatusSimulated)"></div>
                    <p class="text" v-if="showTime(this.gameStatusSimulated)">{{timeNow}}</p>
                  </div>
                  <div v-if="match.currentSetId && match.status === 'sets'" class="period">
                    <p class="text" v-if="!timerHasRan">Set {{ match.currentSetId }}</p>
                  </div>
                  <div v-else class="period">
                    <p class="text" v-if="liveTiming && timeNow">{{ getStatusObjectFromStatusName(this.gameStatusSimulated) ? getStatusObjectFromStatusName(this.gameStatusSimulated).label : this.gameStatusSimulated }}</p>
                    <p class="text quarterStatus" v-else>{{ upperCase(this.gameStatusSimulated).replace('FIRST', '1st').replace('SECOND', '2nd').replace('THIRD', '3rd').replace('FOURTH', '4th') }}</p>
                    <div class="addTimePlus text" v-if="hasAddedTime()">+</div>
                  </div>
                  <div class="timer" v-if="!timerNotRequired && !showTime(this.gameStatusSimulated)">
                    <div class="dot timerDot" v-if="liveTiming && timeNow"></div>
                    <p class="text" v-if="liveTiming && timeNow">{{timeNow}}</p>
                  </div>
                  <div class="">
                    <p class="text" v-if="lastPeriodEnd">(Period End)</p>
                  </div>
                </ion-badge>

                  <!-- <ion-label class="light-text font-size-11" v-for="{memberId, firstName, lastName} in match.referees"
                    :key="memberId">{{firstName}} {{lastName}}</ion-label> -->

                  <div v-if="get(match, 'weather.base')" style="opacity: 1; display: flex; align-items: center; margin-top: auto; flex-shrink: 0">
                        <img height="30" style="margin-right: 7px; object-fit:cover;" :src="require(`@/assets/weather-icons/${match.weather.base.icon}.svg`)" />
                        <div class="temp">
                        <!-- rego.weather.temperature -->
                          <div style="font-size: 12px;">{{ Math.round(match.weather.temperature, 0) }}°C</div>
                          <!-- rego.weather.base.label -->
                          <div style="font-size: 8px">{{match.weather.base.label}}</div>
                        </div>
                      </div>
                </ion-col>
                <ion-col size="4" class="flex flex-column align-center">
                  <TeamLogo :team="get(match, 'awayTeam')" :opacity="true" v-if="!matchIsVs(match)" :competitionId="match.competition" />
                  <TeamLogoVs :team="get(match, 'awayTeam')" v-if="matchIsVs(match)" />
                  <div class="light-text text-center mt-10 team-name notranslate">{{get(match, 'awayTeam.name', get(match, 'meta.isBye') === true ? 'BYE' : 'TBA' )}}</div>
                  <p class="text-center mt-05" v-if="liveTiming && competitionTimeouts > 0">Timeouts Remaining: {{timeoutsRemainingAway}}</p>
                </ion-col>
              </ion-row>
            </ion-grid>

            <!-- <ion-segment scrollable class="custom-segment" :value="segment" @ionChange="segmentChanged($event)" :key="key">
              <ion-segment-button value="team-list">
                <ion-label>
                  <ion-icon :icon="peopleOutline" style="color:white"/>
              </ion-label>
              </ion-segment-button>
              <ion-segment-button value="match-day">
                <ion-label>
                  <ion-icon :icon="flagOutline" style="color:white" />
                </ion-label>
              </ion-segment-button>
            </ion-segment> -->
          </ion-card-content>
        </div>
      </ion-card>
    </div>
    <!-- <div class="notify-me-button">
      <button class="notify-me">Notify Me</button>
    </div> -->
    <div @ionScroll="scrolling" class="match-content">
      <MatchOverview class="mb-20" :match="match" />
      <MatchTeamForm class="mb-20" :homeId="homeTeam ? homeTeam._id : null" :awayId="awayTeam ? awayTeam._id : null" />
      <MatchTeamList class="mb-20" type="home" v-if="!matchIsVs(match)" />
      <MatchTeamList class="mb-20" type="away" v-if="!matchIsVs(match)" />
      <div class="d-grid gap-10" v-if="matchEvents && matchEvents.length">
        <ion-grid :key="key" :scroll-x="true" class="period-row ml-10 mt-10" :style="{'white-space': 'nowrap', 'padding-top': '1rem'}" nowrap>
          <ion-chip v-for="(evs, index) in eventsPeriodSegments()" :key="index" @click="periodSegment = evs.period; key++;" :class="{
            'mr-10': true,
            chip: true,
            active: periodSegment === 0 && evs.period === 0 || (periodSegment && periodSegment === evs.period),

          }">
            <ion-label>{{ evs.label === 'All' ? 'Match Events' : evs.label }}</ion-label>
          </ion-chip>
        </ion-grid>
        <Timeline :events="matchEvents" :periodSegment="periodSegment" :key="key" v-if="matchEvents && matchEvents.length"/>
      </div>

      <!-- <div v-if="loaded && segment === 'team-list'" class="teamlist-container">
        <table-grid-mobile-with-search
        v-if="generatedPlayerStats && isMultiSport"
        :title="generatedPlayerStats.label"
        :headers="generatedPlayerStats.headers"
        :rows="generatedPlayerStats.rows"
        />
        <TeamList v-if="match._id && (match.display && match.display.teamlists === true)" :match="match"/>
        <div v-else-if="(match.display && match.display.teamlists === false)" class="empty-container flex flex-column justify-center">
            <ion-text>
              <h1 class="empty-placeholder">Teamlists Not Available to Public</h1>
            </ion-text>
        </div>
        <ion-grid class="empty-container" v-else>
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">No Teamlists Available</h1>
            </ion-text>
          </ion-card>
        </ion-grid>
      </div>
      <div v-if="loaded && segment === 'match-day'">
        <ion-grid :key="key" :scroll-x="true" class="period-row ml-10 mt-10" style="{'white-space': 'nowrap', 'padding-top': '1rem', background: $background !important}" nowrap>
          <ion-chip v-for="(evs, index) in eventsPeriodSegments()" :key="index" @click="periodSegment = evs.period; key++;" :class="{
            'mr-10': true,
            chip: true,
            active: periodSegment === 0 && evs.period === 0 || (periodSegment && periodSegment === evs.period),

          }">
            <ion-label>{{ evs.label }}</ion-label>
          </ion-chip>
        </ion-grid>
        <Timeline :events="matchEvents" :periodSegment="periodSegment" :key="key"/>
      </div> -->
    </div>
  </ion-page>
</template>

<script>
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import _, { upperCase } from 'lodash';
import { roles } from '@/utils/roles';
import {
  arrowBackOutline,
  arrowForwardOutline,
  shareSocialOutline,
  documentTextOutline,
  ellipsisVertical,
  peopleOutline,
  footballOutline,
  flagOutline,
  podiumOutline,
} from "ionicons/icons";
import { useSound } from '@vueuse/sound'
import { loadingController, toastController } from "@ionic/vue";
import { useRoute } from 'vue-router';
import { mapGetters } from "vuex";
import { ref, computed, onMounted, onUnmounted, getCurrentInstance } from 'vue';
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import TeamList from './components/team-list';
import Timeline from '../../components/Timeline.vue';
import PerPeriodScore from '../../components/PerPeriodScore.vue';
import TeamLogo from './base/team-logo';
import TeamLogoVs from './base/team-logo-vs.vue';
import { fetchMatchEventData,fetchTeamListData } from '@/actions/match';
import goal from '../../assets/sfx/goal.mp3';
import TableGridMobileWithSearch from '@/components/TableGridMobileWithSearch';

import MatchOverview from '@/components/match/Overview.vue';
import MatchTeamForm from '@/components/match/TeamForm.vue';
import MatchTeamList from '@/components/match/TeamList.vue';


import { generate } from '@vue/compiler-core';
import moment from 'moment-timezone';
const Timer = require('@/utils/timer');

export default {
  name: 'Match',
  components: {
    // TeamList,
    // TableGridMobileWithSearch,
    PerPeriodScore,
    Timeline,
    TeamLogo,
    TeamLogoVs,
    MatchOverview,
    MatchTeamForm,
    MatchTeamList,
  },
  setup() {
    const app = getCurrentInstance();
    const route = useRoute();
    const { $store, $pusher } = app.appContext.config.globalProperties
    const { dispatch, getters, commit } = $store;

    const segment = ref("team-list");
    const isOffline = ref('false');
    const key = ref(0);
    const loaded = ref(false);
    const match = computed(() => getters['match/matchDetails']);
    const tableData = _.get(match, 'value.tableData') ? _.get(match, 'value.tableData') : {headers: [], rows: [], label: 'N/A'};
    const selectedTeamId = computed(() => getters["match/selectedTeamId"]);
    const laddertemplate = computed(() => getters['matches/getLaddertemplate']);
    const matchEvents = computed(() => getters['match/matchEvents']);
    const matchScorings = computed(() => getters['match/matchScorings']);
    const matchMovements = computed(() => getters['match/matchMovements']);
    const homeScore = computed(() => getters['match/homeScore']);
    const awayScore = computed(() => getters['match/awayScore']);
    const homeTeam = computed(() => getters['match/homeTeam']);
    const awayTeam = computed(() => getters['match/awayTeam']);
    const nationalId = ref(+process.env.VUE_APP_NATIONAL_ID);
    const currentSetScores = computed(() => {
      const { setScores, currentSetId } = match.value;
      const currentSet = setScores.find(set => set.setId === currentSetId);
      if (!currentSet || !currentSet.scores) return '';
      const { scores: { homeTeam, awayTeam } } = currentSet;
      return `${homeTeam}-${awayTeam}`;
    })

    const penalties =computed(() => {
      const { scoringEvents  } = match.value;
      const penaltyEvents = scoringEvents.filter(ev => ev.name.toLowerCase().includes('penalty'));
      // fill at least 5 of isHomeTeam true and 5 isHomeTeam false if not enough
      const homePenalties = penaltyEvents.filter(ev => ev.teamId === match.value.homeTeam?._id);
      const awayPenalties = penaltyEvents.filter(ev => ev.teamId === match.value.awayTeam?._id);
      const homePenaltiesCount = homePenalties.length;
      const awayPenaltiesCount = awayPenalties.length;
      const homePenaltiesToFill = 5 - homePenaltiesCount;
      const awayPenaltiesToFill = 5 - awayPenaltiesCount;
      for (let i = 0; i < homePenaltiesToFill; i++) {
        homePenalties.push({ isHomeTeam: true, _id: i });
      }
      for (let i = 0; i < awayPenaltiesToFill; i++) {
        awayPenalties.push({ isHomeTeam: false, _id: i });
      }
      return [...homePenalties, ...awayPenalties];
    })

    const gameStatus = computed(() => {
      if (_.get(isOffline, 'value') === true) return 'offline'
      return getters['match/gameStatus']
    });
    const gameStatusColor = computed(() => {
      switch (_.get(gameStatus, 'value')) {
      case 'pre-game':
        return 'dark';
      case 'final':
        return 'success';
      case 'forfeit':
      case 'washout':
        return 'warning';
      case 'disputed':
      case 'offline':
        return 'danger';
      case 'first-half':
      case 'second-half':
        return 'light';
      default:
        return 'light';
      }
    })

    const segmentChanged = (event) => {
      segment.value = _.get(event, 'detail.value');
    };

    const updateSelectedTeam = async id => {
      const { homeTeamList, awayTeamList } = await fetchMatchEventData(_.get(match, 'value'));
      commit('match/setCurrentTeam', +id === _.get(match, 'value.homeTeam._id')
        ? { _id: +id, isHomeTeam: true }
        : { _id: +id, isHomeTeam: false })

      commit('match/setCurrentTeamData', +id === _.get(match, 'value.homeTeam._id')
        ? homeTeamList
        : awayTeamList);
      commit('match/setSelectedTeamId', +id )
      segment.value = 'team-list';
    }

    const getScore = type => {
      const hasPenaltyPeriod = match.value.scoringEvents.some(ev => ev.name.toLowerCase().includes('penalty') && ev.period === 9999);
      if(type === 'homeTeam'){
        // if(gameStatus.value === 'forfeit'){
        //   const isForfeitingTeam = match.value.homeTeam.name === match.value.meta.forfeitingTeam.name
        //   return isForfeitingTeam ? 0 : _.get(laddertemplate.value, 'defaultScoreFFReceived')
        // }
        if(gameStatus.value === 'penalty' || hasPenaltyPeriod) {
          const homeMainScore = homeScore.value;
          const homePenScoreEvents = match.value.scoringEvents
            .filter(ev =>
              ev.name.toLowerCase().includes('penalty') &&
              !ev.name.toLowerCase().includes('miss') &&
              ev.teamId === match.value?.homeTeam?._id
            )
          const homePenScore = homePenScoreEvents
            .reduce((acc, cur) => acc + 1, 0);
          const homePenScoreValues = homePenScoreEvents
            .reduce((acc, cur) => acc + cur.value, 0);
          return `(${homePenScore}) ${homeMainScore - homePenScoreValues}`;
        }
        return homeScore.value;
      }else if( type === 'awayTeam'){
        // if(gameStatus.value === 'forfeit') {
        //   const isForfeitingTeam = match.value.awayTeam.name === match.value.meta.forfeitingTeam.name
        //   return isForfeitingTeam ? 0: _.get(laddertemplate.value, 'defaultScoreFFReceived')
        // }
        if (gameStatus.value === 'penalty' || hasPenaltyPeriod) {
          const awayMainScore = awayScore.value;
          const awayPenScoreEvents = match.value.scoringEvents
            .filter(ev =>
              ev.name.toLowerCase().includes('penalty') &&
              !ev.name.toLowerCase().includes('miss') &&
              ev.teamId === match.value.awayTeam._id
            )
          const awayPenScore = awayPenScoreEvents
            .reduce((acc, cur) => acc + 1, 0);
          const awayPenScoreValues = awayPenScoreEvents
            .reduce((acc, cur) => acc + cur.value, 0);
          return `${awayMainScore - awayPenScoreValues} (${awayPenScore})`;
        }
        return awayScore.value;
      }
    }

    const fieldDisplayName = field => {
      if (!field || !field.name) return '';
      if (!field.surface || field.surface === 'N/A') return field.name;
      return `${field.name} (${field.surface})`;
    }

    const getTeam = gameStatus => {
      return gameStatus === 'forfeit'? _.get(match, 'value.meta.forfeitingTeam.name'): '';
    }

    const checkForfeit = type => {
      if(type === 'homeTeam'){
        if(gameStatus.value === 'forfeit'){
          const isForfeitingTeam = _.get(match.value, 'homeTeam.name','') === _.get(match.value, 'meta.forfeitingTeam.name','')
          return isForfeitingTeam ? true : false
        }
        return false;
      }else if( type === 'awayTeam'){
        if(gameStatus.value === 'forfeit') {
          const isForfeitingTeam = _.get(match.value, 'awayTeam.name','') === _.get(match.value, 'meta.forfeitingTeam.name','')
          return isForfeitingTeam ? true: false
        }
        return false;
      }
    }

    const getLaddertemplate = async () => {
      const {laddertemplate} = await fetchTeamListData(match.value);
      commit('matches/setLaddertemplate', laddertemplate);
    }

    const updateOnlineStatus = (e) => isOffline.value = e.type === 'offline'

    const goalSound = useSound(goal, { volume: 0.5 });
    const { play } = goalSound;

    onMounted(async () => {
      const { id } = route.params;
      // const loading = await loadingController.create({ message: "Loading matches..." })
      // loading.present();
      await dispatch('match/setup', { id });
      loaded.value = true;
      // loading.dismiss();

      if(match.value.competition._id !== undefined){
        await getLaddertemplate();
      }

      // Offline handler
      window.addEventListener('offline', updateOnlineStatus);
      window.addEventListener('online', updateOnlineStatus);

      const pusherChannel = $pusher.subscribe(`match-${id}`);
      pusherChannel.bind('status', (data) => {
        const { status, forfeitingTeam } = data;
        commit('match/setStatus', status);
        match.value.meta.forfeitingTeam = forfeitingTeam;
      });

      pusherChannel.bind('event:add', async (data) => {
        const { event, type } = data;
        const eventType = type === 'movement' ? 'playerMovements' : 'scoringEvents';
        const eventArray = type === 'movement' ? matchMovements : matchScorings
        $store.commit('match/setEvents', { type: eventType, events: eventArray.value.concat([event]) });

        if (type === 'scoring') {
          // play();
          const message = _.get(event, 'meta.player.firstName') && _.get(event, 'meta.player.lastName')
            ? `${event.name} - ${_.get(event, 'meta.player.firstName','')} ${_.get(event, 'meta.player.lastName','')}`
            : `${event.name}`;
          const toast = await toastController
            .create({
              color: 'warning',
              header: `${event.isHomeTeam ? match.value.homeTeam.name : match.value.awayTeam.name}`,
              message,
              position: 'bottom',
              duration: 3500,
              buttons: [{
                side: 'start',
                icon: footballOutline,
              }]
            })
          await toast.present();
        }
        key.value++;
      });

      pusherChannel.bind('event:remove', (data) => {
        const { eventId, type } = data;
        console.log({
          eventId
        });
        const eventType = type === 'movement' ? 'playerMovements' : 'scoringEvents';
        const eventArray = type === 'movement' ? matchMovements : matchScorings
        console.log({
          eventType,
          eventArray,
          events: eventArray.value.filter(e => e._id !== eventId)
        });
        $store.commit('match/setEvents', { type: eventType, events: eventArray.value.filter(e => e._id !== eventId) });
        key.value++;
      });

    })

    onUnmounted(() => {
      commit('match/clear');
    })


    return {
      getLaddertemplate,
      checkForfeit,
      fieldDisplayName,
      arrowForwardOutline,
      getTeam,
      get: _.get,
      upperCase,
      segment,
      match,
      ellipsisVertical,
      shareSocialOutline,
      documentTextOutline,
      arrowBackOutline,
      segmentChanged,
      key,
      nationalId,
      loaded,
      homeScore,
      awayScore,
      gameStatus,
      gameStatusColor,
      isOffline,
      peopleOutline,
      flagOutline,
      podiumOutline,
      roles,
      selectedTeamId,
      updateSelectedTeam,
      matchEvents,
      getScore,
      tableData,
      currentSetScores,
      penalties,
      homeTeam,
      awayTeam,
    }
  },
  data() {
    return {
      sportType: 'soccer',
      timerData: {},
      timeoutsRemainingHome: 0,
      timeoutsRemainingAway: 0,
      timerPusherChannel: {},
      matchId: 0,
      timer: new Timer(),
      timeNow: '',
      timeoutsRemaining: 0,
      competitionTimeouts: 0,
      currentPeriod: 1,
      gameStatusPeriod: {
        'first-quarter': {period: 1},
        'second-quarter': {period: 2},
        'third-quarter': {period: 3},
        'fourth-quarter': {period: 4},
        'first-half': {period: 1},
        'second-half': {period: 2},
      },
      liveTiming: false,
      currentStatus: '',
      nextStatus: '',
      intervalGetter: {},
      playerStats: {
        headers: [],
        rows: []
      },
      timerHasEnded: false,
      periodSegment: 0,
      statusEquivalence: [
        {
          value: 'first-half',
          period: 1,
          periodType: 2,
          label: 'First Half',
        },
        {
          value: 'second-half',
          period: 2,
          periodType: 2,
          label: 'Second Half',
        },
        {
          value: 'final',
          period: 3,
          periodType: 2,
          label: 'Final',
        },
        {
          value: 'first-quarter',
          period: 1,
          periodType: 4,
          label: 'First Quarter',
        },
        {
          value: 'second-quarter',
          period: 2,
          periodType: 4,
          label: 'Second Quarter',
        },
        {
          value: 'third-quarter',
          period: 3,
          periodType: 4,
          label: 'Third Quarter',
        },
        {
          value: 'fourth-quarter',
          period: 4,
          periodType: 4,
          label: 'Fourth Quarter',
        },
        {
          value: 'final',
          period: 5,
          periodType: 4,
          label: 'Final',
        },
        {
          value: 'first-period',
          period: 1,
          periodType: 3,
          label: 'First Period',
        },
        {
          value: 'second-period',
          period: 2,
          periodType: 3,
          label: 'Second Period',
        },
        {
          value: 'third-period',
          period: 3,
          periodType: 3,
          label: 'Third Period',
        },
        {
          value: 'final',
          period: 4,
          periodType: 3,
          label: 'Final',
        },
      ],
    };
  },
  async mounted() {
    const app = getCurrentInstance();
    const { $store, $pusher } = app.appContext.config.globalProperties;
    this.pusher = $pusher;
    // this.changeDateTimeToTimezone([{
    //   matches: [this.match]
    // }]);
    const matchId = window.location.pathname.split('/')[2];
    this.matchId = +matchId;
    const matchDetails = $store.getters['match/matchDetails'];
    const matchStatusLocal = $store.getters['match/gameStatus'];
    const matchRes = await $store.dispatch('match/matchResponse', { id: matchId });
    const generatedPeriods = _.get(matchRes, 'data.data.generatedPeriods', undefined);
    const allMatchStatuses = _.get(matchRes, 'data.data.allMatchStatuses');
    if (allMatchStatuses) {
      this.statusEquivalence = allMatchStatuses;
    }
    // if (generatedPeriods && generatedPeriods.length > 0) {
    //   // this.statusEquivalence = generatedPeriods;
    //   this.statusEquivalence = [...generatedPeriods, ...this.statusEquivalence];
    // }
    // console.log({
    //   matchStatusLocal
    // });
    // this.currentStatus = matchStatusLocal;
    // const currentPeriod = _.find(this.statusEquivalence, sE => sE.value == matchStatusLocal);
    // const nextPeriod = _.find(this.statusEquivalence, sE => sE.type == currentPeriod.type && sE.period == currentPeriod.period + 1);
    // this.nextStatus = nextPeriod.value;
    //
    // console.log({
    //   currentStatus: this.currentStatus,
    //   nextStatus: this.nextStatus,
    // });
    // this.currentPeriod = currentPeriod;

    this.sportType = _.get(matchDetails, 'sportType.value', -1);
    const playerStats = await this.$httpNoAuth.get(`/assemble/api/v1/live/matches/${matchId}/sport/`);
    this.playerStats = _.get(playerStats, 'data.data.tableData', {});

    const resLiveTiming = await this.$http.get(`assemble/api/v1/live/matches/${this.matchId}/checkLiveTiming`);
    const liveTiming = _.get(resLiveTiming, 'data.data.liveTiming', false);
    this.liveTiming = liveTiming;
    console.log({
      liveTiming
    });
    if (liveTiming) {
      const res = await this.$http.get(`assemble/api/v1/live/matches/${matchId}/timer`);
      const { currentTime, competitionTimeouts, matchTimeouts, periodLengthMillis, hasEnded } = _.get(res, 'data.data');
      this.competitionTimeouts = competitionTimeouts;
      this.pusherChannel = `match-timer-${matchId}`;
      let pusherChannel = this.pusher.subscribe(this.pusherChannel);
      this.timer.subscribe(this.updateTime)
      pusherChannel.bind('create', (data) => {
        const { event, type } = data;
        // this.timer.stop().stopWithTime(event.timeElapse + (Date.now() - event.timeSent), event.timeEnd);
        const correctedTime = this.correctTime(event);
        console.log('Create');
        console.log({
          correctedTime
        });
        this.timerData = event;
        this.timerHasEnded = false;
        this.timer.stop().stopWithTime(event.timeElapse, event.timeEnd);
      });
      pusherChannel.bind('stop', (data) => {
        const { event, type } = data;
        const correctedTime = this.correctTime(event);
        this.timerData = event;
        this.timerHasEnded = false;
        this.timer.stopWithTime(correctedTime.timeElapse, correctedTime.timeRemaining);
        // this.timeoutsRemaining = event.competitionTimeouts - event.matchTimeouts;
        this.timeoutsRemainingHome = event.competitionTimeouts - event.matchTimeouts.homeTeam;
        this.timeoutsRemainingAway = event.competitionTimeouts - event.matchTimeouts.awayTeam;
        console.log({
          timeoutsRemainingHome: this.timeoutsRemainingHome,
          timeoutsRemainingAway: this.timeoutsRemainingAway
        })
        this.timeoutsRemainingHome = isNaN(this.timeoutsRemainingHome) ? event.competitionTimeouts : this.timeoutsRemainingHome;
        this.timeoutsRemainingAway = isNaN(this.timeoutsRemainingAway) ? event.competitionTimeouts : this.timeoutsRemainingAway;
        console.log({
          timeoutsRemainingHome: this.timeoutsRemainingHome,
          timeoutsRemainingAway: this.timeoutsRemainingAway
        })
        // if (event.playerMovements) {
        //   this.$store.commit('match/setEvents', { type: 'playerMovements', events: event.playerMovements });
        // }
        // if (event.scoringEvents) {
        //   this.$store.commit('match/setEvents', { type: 'scoringEvents', events: event.scoringEvents });
        // }
      });
      pusherChannel.bind('start', (data) => {
        const { event, type, status } = data;
        // this.timer.stop().startFromAndEndTo(event.timeStart, event.timeElapse + (Date.now() - event.timeSent), event.timeEnd);
        const correctedTime = this.correctTime(event);
        this.timerHasEnded = false;
        if (status) {
          $store.commit('match/setStatus', status);
        }
        this.timerData = event;
        this.timer.stop().startFromAndEndTo(correctedTime.timeStart, correctedTime.timeElapse, correctedTime.timeEnd);
      });
      pusherChannel.bind('update', (data) => {
        const { events, event, type, status, hasEnded } = data;
        if (event) {
          this.timerData = event;
          const correctedTime = this.correctTime(event);
          $store.commit('match/setStatus', status);
          // this.timer.update(event.timeElapse);
          this.timer.stopWithTime(correctedTime.timeElapse, correctedTime.timeRemaining);
          try {
            this.timerHasEnded = hasEnded;
          } catch (e) {
            console.log(e);
          }
        }
        if (events.playerMovements) {
          this.$store.commit('match/setEvents', { type: 'playerMovements', events: events.playerMovements });
        }
        if (events.scoringEvents) {
          this.$store.commit('match/setEvents', { type: 'scoringEvents', events: events.scoringEvents });
        }
      });

      const pusherChannelMatch = this.pusher.subscribe(`match-${matchId}`);
      pusherChannelMatch.bind('event:refresh', async (data) => {
        const { event, type } = data;
        const matchRes = await this.$http.get(`assemble/api/v1/live/matches/${this.matchId}`);
        const matchData = _.get(matchRes, 'data.data');
        const playerMovements = _.get(matchData, 'playerMovements');
        if (type === 'movement') {
          const movements = this.$store.getters["match/matchMovements"];
          console.log({
            movements
          });
          const eventType = 'playerMovements';
          this.$store.commit('match/setEvents', { type: eventType, events: playerMovements });
        }
      });


      if (currentTime) {
        this.timerData = currentTime;
        this.timerHasEnded = hasEnded
        const correctedTime = this.correctTime(currentTime);
        console.log('Init');
        console.log({
          correctedTime
        });
        if(!currentTime.stopped) {
          // this.timer.startFromAndEndTo(currentTime.timeStart, currentTime.timeElapse + (Date.now() - currentTime.timeSent), currentTime.timeEnd);
          this.timer.startFromAndEndTo(correctedTime.timeStart, correctedTime.timeElapse, correctedTime.timeEnd);
        } else {
          this.timer.stopWithTime(correctedTime.timeElapse, correctedTime.timeRemaining);
        }
      }

      // this.timer.subscribeEnd(async (time) => {
      //   const matchStatus = $store.getters['match/gameStatus'];
      //   this.timerHasEnded = true;
      //   const currentStatus = _.find(this.statusEquivalence, sE => _.get(sE, 'value') == matchStatus);
      //   const statuses = _.filter(this.statusEquivalence, sE => _.get(sE, 'periodType') === _.get(currentStatus, 'periodType'));
      //   const nextStatus = _.find(statuses, s => s.period == currentStatus.period + 1);
      //   // $store.commit('match/setStatus', nextStatus.value);
      //   const periodStartComputed = periodLengthMillis * (nextStatus.period - 1);
      //   const periodEndComputed = periodLengthMillis * (nextStatus.period);
      //   console.log({
      //     periodStartComputed,
      //     periodEndComputed
      //   });
      //   this.timer.stopWithTime(periodStartComputed, periodLengthMillis);
      //   const minAndSec = this.getTimeMinAndSec();
      //   const movements = this.$store.getters["match/matchMovements"];
      //   console.log({
      //     match: this.match.scores.homeTeam
      //   });
      //   const eventEOP = [{
      //     name: `End of Period ${currentStatus.period} (${this.match.scores.homeTeam}-${this.match.scores.awayTeam})`,
      //     type: 0,
      //     teamId: 0,
      //     isHomeTeam: true,
      //     min: minAndSec.MM,
      //     sec: minAndSec.SS
      //   }];
      //   console.log({
      //     eventEOP
      //   });
      //   // this.currentPeriod = currentStatus;
      //   this.$store.commit('match/setEvents', { type: 'playerMovements', events: movements.concat(eventEOP) });
      //   const res = await this.$http.post(`assemble/api/v1/live/matches/${this.matchId}/timer/end`);
      //   console.log({
      //     res
      //   })
      //   const endTimeData = _.get(res, 'data.data.time', {});
      //   if (endTimeData) {
      //     this.timerData = endTimeData;
      //   }

      //   // const playerMovements = _.get(res, 'data.data.playerMovements', []);
      //   // const scoringEvents = _.get(res, 'data.data.scoringEvents', []);
      //   // if (playerMovements) {
      //   //   this.$store.commit('match/setEvents', { type: 'playerMovements', events: playerMovements });
      //   // }
      //   // if (scoringEvents) {
      //   //   this.$store.commit('match/setEvents', { type: 'scoringEvents', events: scoringEvents });
      //   // }
      //   // const responseStatus = _.get(res, 'data.data.status');
      //   // $store.commit('match/setStatus', responseStatus);

      // });

      // this.timeoutsRemainingHome = competitionTimeouts - matchTimeouts.homeTeam;
      // this.timeoutsRemainingAway = competitionTimeouts - matchTimeouts.awayTeam;
      // this.timeoutsRemainingHome = isNaN(this.timeoutsRemainingHome) ? competitionTimeouts : this.timeoutsRemainingHome;
      // this.timeoutsRemainingAway = isNaN(this.timeoutsRemainingAway) ? competitionTimeouts : this.timeoutsRemainingAway;

      // this.intervalGetter = setInterval(async () => {
      //   console.log('Getting Timer Data');
      //   const res = await this.$http.get(`assemble/api/v1/live/matches/${this.matchId}/timer`);
      //   console.log({
      //     res
      //   })
      //   const { currentTime, competitionTimeouts, matchTimeouts, liveTiming, periodLengthMillis, hasEnded } = _.get(res, 'data.data');
      //   const playerMovements = _.get(res, 'data.data.playerMovements', []);
      //   const scoringEvents = _.get(res, 'data.data.scoringEvents', []);
      //   if (playerMovements) {
      //     this.$store.commit('match/setEvents', { type: 'playerMovements', events: playerMovements });
      //   }
      //   if (scoringEvents) {
      //     this.$store.commit('match/setEvents', { type: 'scoringEvents', events: scoringEvents });
      //   }
      //   const responseStatus = _.get(res, 'data.data.status');
      //   // if (nextStatus.value == responseStatus) {
      //   $store.commit('match/setStatus', responseStatus);
      //   console.log({
      //     hasEnded
      //   });
      //   if (currentTime) {
      //     this.timerData = currentTime;
      //     this.timerHasEnded = hasEnded
      //     const correctedTime = this.correctTime(currentTime);
      //     console.log('Get Time');
      //     console.log({
      //       correctedTime
      //     });
      //     if(!currentTime.stopped) {
      //       // this.timer.startFromAndEndTo(currentTime.timeStart, currentTime.timeElapse + (Date.now() - currentTime.timeSent), currentTime.timeEnd);
      //       this.timer.startFromAndEndTo(correctedTime.timeStart, correctedTime.timeElapse, correctedTime.timeEnd);
      //     } else {
      //       this.timer.stopWithTime(correctedTime.timeElapse, correctedTime.timeRemaining);
      //     }
      //   }
      // }, 10000);
    }

    const setPusherChannelId = `match-setscores-${matchId}`;
    const setPusherChannel = this.pusher.subscribe(setPusherChannelId);
    setPusherChannel.bind('event:setScore', (data) => {
      const { set } = data;
      const { setScores } = this.match;
      const foundSet = setScores.findIndex(s => s.setId === set.setId);
      const updatedSetScores = [...setScores];
      if (foundSet) updatedSetScores[foundSet] = set;
      else updatedSetScores.push(set);
      this.$store.commit('match/setSetScores', updatedSetScores);
    });

    setPusherChannel.bind('event:endSet', (data) => {
      const { setScores, currentSetId, scoringEvents, scores } = data;

      this.$store.commit('match/setSetScores', setScores);
      this.$store.commit('match/setCurrentSetId', currentSetId);
      this.$store.commit('match/setEvents', { scoringEvents, type: 'scoringEvents' });
      this.$store.commit('match/setScores', scores);
    });

    setPusherChannel.bind('event:modifySetScores', (data) => {
      const { setScores, scoringEvents, scores } = data;

      this.$store.commit('match/setSetScores', setScores);
      this.$store.commit('match/setEvents', { scoringEvents, type: 'scoringEvents' });
      this.$store.commit('match/setScores', scores);
    });

    setPusherChannel.bind('event:removeSet', (data) => {
      const { setScores, scoringEvents, scores } = data;

      this.$store.commit('match/setSetScores', setScores);
      this.$store.commit('match/setEvents', { scoringEvents, type: 'scoringEvents' });
      this.$store.commit('match/setScores', scores);
    });

  },
  unmounted() {
    this.pusher.unsubscribe(this.pusherChannel);
    clearInterval(this.intervalGetter);
  },
  methods: {
    changeDateTimeToTimezone(pools) {
      const timezoneClients = [21, 22];
      if (!timezoneClients.includes(+process.env.VUE_APP_NATIONAL_ID)) {
        return;
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const pool of pools) {
        const { matches } = pool || {};
        // eslint-disable-next-line no-restricted-syntax
        for (const match of matches) {
          const dateTimeTimezone = utcToZonedTime(match.dateTime, this.timezone);
          match.dateTime = dateTimeTimezone.valueOf();
          match.dateTimeTimezone = dateTimeTimezone;
        }
      }
    },
    matchIsVs(match) {
      return _.get(match, 'competitionSettings.type') === 'vs';
    },
    changePeriod(evs) {
      this.periodSegment = evs;
      this.key++;
    },
    ordinalSuffix(i) {
      const j = i % 10;
      const k = i % 100;
      if (j === 1 && k !== 11) {
        return `${i}st`;
      }
      if (j === 2 && k !== 12) {
        return `${i}nd`;
      }
      if (j === 3 && k !== 13) {
        return `${i}rd`;
      }
      return `${i}th`;
    },
    eventsPeriodSegments() {
      // const generatedPeriods = _.get(this.match, 'generatedPeriods');
      // let filterGeneratePeriods = _.filter(generatedPeriods, gp => _.get(gp, 'period') <= _.get(gp, 'periodType'));
      const columns =_.get(this.match, 'periods');
      const penalties = _.get(this.match, 'scoringEvents').filter(se => se.period === 9999); // penalties
      const periodsLabel = [];
      for (let i = 0; i < columns; i++) {
        const suffixed = this.ordinalSuffix(i+1);
        periodsLabel.push({
          label: suffixed,
          period: i + 1
        });
      }

      if (penalties.length) {
        periodsLabel.push({
          label: 'Penalties',
          period: 9999
        });
      }

      const filterGeneratePeriods = [
        {
          label: 'All',
          period: 0,
        },
        // ...filterGeneratePeriods,
        ...periodsLabel
      ];
      return filterGeneratePeriods;
    },
    segmentPeriodChange(event) {
      this.periodSegment = +event.detail.value;
      this.key++;
    },
    getPlayerStats() {
      try {
        return _.get(this.match, 'tableData.playerStats')
      } catch (e) {
        console.log(e);
      }
      return false
    },
    getMatchDate(match) {
      return moment(_.get(match, 'dateTime' )).tz(this.timezone).format('LLL')
    },
    hasAddedTime() {
      const statusObject = this.getStatusObjectFromStatusName(this.gameStatusSimulated);
      const addedTime = _.get(this.timerData, 'addedTime');
      const periodAddedTime = _.filter(addedTime, (at) => at.period === _.get(statusObject, 'period'));
      if (this.timer && (this.timer.useRemaining === false || periodAddedTime.length > 0)) {
        return true;
      }
      return false;
    },
    correctTime(currentTime) {
      // const timeSent = currentTime.timeSent ? Date.now() - currentTime.timeSent : 0;
      // const timeElapse = currentTime.timeElapse - timeSent;
      const timeElapse = currentTime.timeElapse;
      let additionalTime = 0;
      if (timeElapse < 0) {
        additionalTime = timeElapse * -1;
      }
      currentTime.timeElapse = timeElapse + additionalTime;
      currentTime.timeStart = currentTime.timeStart + additionalTime;
      currentTime.timeStart = currentTime.timeEnd + additionalTime;
      return currentTime;
    },
    getTimeMinAndSec() {
      const time = this.timer.getTime();
      const seconds = time.timeElapse / 1000;
      let MM = Math.floor((seconds) / 60);
      let SS = Math.floor(seconds % 60);
      MM = MM ? MM : 0;
      SS = SS ? SS : 0;
      return {
        MM,
        SS
      };
    },
    getStatusObjectFromStatusName(status) {
      return _.find(this.statusEquivalence, (se) => _.get(se, 'value') == status);
    },
    showTime(status) {
      const statusObject = this.getStatusObjectFromStatusName(status)
      const value = _.get(statusObject, 'value', '');
      const period = _.get(statusObject, 'period');
      return ((period
      || value.includes('-quarter')
      || value.includes('-period')
      || value.includes('-half'))
      && value !== 'half-time'
      && value !== 'final')
      && value !== 'washout'
      && this.liveTiming;
    },
    updateTime(time) {
      const seconds = time.timeElapse / 1000;
      const MM = Math.floor((seconds) / 60);
      const SS = Math.floor(seconds % 60);
      const minString = MM.toString().length < 2 ? ("0" + MM).slice(-2) : MM;
      this.timeNow = `${minString}:${("0" + SS).slice(-2)}`;
    },
    goBack() {
      this.$pusher.unsubscribe(`match-${this.match._id}`);
      this.$router.back();
    },
    async getMatchReport() {
      const value = this.match;
      if (!value.homeTeam || !value.awayTeam || value.meta.isTba || value.meta.isBye) {
        const toast = await toastController
          .create({
            color: 'warning',
            header: 'Team List Unavailable',
            message: 'Match report is not available because teams are not finalised',
            position: 'bottom',
            duration: 3500,
            buttons: [{
              side: 'start',
              icon: footballOutline,
            }]
          })
        return await toast.present();
      }
      if (pdfMake.vfs === undefined) pdfMake.vfs = pdfFonts.pdfMake.vfs;
      const dd = await this.$http.get(`/assemble/api/v1/live/matches/${value._id}/match-report`);
      dd.data.data.content.unshift('\n');
      dd.data.data.content.unshift({ image: 'logo', width: [100], alignment: 'center' });
      dd.data.data.images = { logo: await this.getBase64Logo() };
      return pdfMake.createPdf(dd.data.data).download(`${value._id}-match-report.pdf`);
    },
    async downloadMemberList() {
      const value = this.match;
      if (!value.homeTeam || !value.awayTeam || value.meta.isTba || value.meta.isBye) {
        const toast = await toastController
          .create({
            color: 'warning',
            header: 'Team List Unavailable',
            message: 'Member list is not available because teams are not finalised',
            position: 'bottom',
            duration: 3500,
            buttons: [{
              side: 'start',
              icon: footballOutline,
            }]
          })
        return await toast.present();
      }
      if (pdfMake.vfs === undefined) pdfMake.vfs = pdfFonts.pdfMake.vfs;
      const homeDD = await this.$http.get(`/assemble/api/v1/live/matches/${value._id}/player-list-report/homeTeam`);
      const awayDD = await this.$http.get(`/assemble/api/v1/live/matches/${value._id}/player-list-report/awayTeam`);
      homeDD.data.data.content.unshift('\n');
      homeDD.data.data.content.unshift({ image: 'logo', width: [100], alignment: 'center' });
      homeDD.data.data.images = { logo: await this.getBase64Logo() };
      awayDD.data.data.content.unshift('\n');
      awayDD.data.data.content.unshift({ image: 'logo', width: [100], alignment: 'center' });
      awayDD.data.data.images = { logo: await this.getBase64Logo() };
      pdfMake.createPdf(homeDD.data.data).download(`${value._id}-member-list.pdf`);
      return pdfMake.createPdf(awayDD.data.data).download(`${value._id}-member-list.pdf`);
    },
    getBase64Logo() {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.setAttribute('crossOrigin', 'anonymous');
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          const dataURL = canvas.toDataURL('image/png');
          resolve(dataURL);
        };
        img.onerror = (error) => {
          reject(error);
        };
        img.src = `${ process.env.VUE_APP_LOGO || 'https://upload.wikimedia.org/wikipedia/en/b/b5/Kosovo_Handball_Federation.jpg' }?r=${ Math.floor(Math.random() * 100000)}`;
      });
    },
  },
  computed: {
    setScoreTotal() {
      const setScores = this.$store.getters["match/setScores"];
      if (!setScores) return {};
      const homeMatchScore = this.homeScore;
      const awayMatchScore = this.awayScore;
      return {
        home: homeMatchScore,
        away: awayMatchScore
      };
    },
    filteredMatchEvents() {
      if (!this.match || !this.match.scoringEvents) return [];
      if (!this.periodSegment) return this.match.scoringEvents;
      return this.match.scoringEvents.filter(event => event.period === this.periodSegment);
    },
    perPeriodScoreData() {
      const setScores = this.$store.getters["match/setScores"];
      if (!this.match || this.match && setScores) return {};
      const periodsList = _.filter(this.statusEquivalence, (se) => _.get(se, 'period') && _.get(se, 'value') !== 'final');
      const headers = [];
      const rows = [];
      const homeRow = [];
      const awayRow = [];
      let tempHeader = '';
      let tempIndex = 0;
      for (let i = 0; i < periodsList.length; i++) {
        let header = _.get(periodsList[i], 'abbreviation');
        if (tempHeader !== header) {
          if (!header) {
            header = _.get(periodsList[i], 'period')
          }
          headers.push(header);
        }

        const periodScoresHome = _.filter(this.match.scoringEvents, (se) => _.get(se, 'period') === _.get(periodsList[i], 'period') && _.get(se, 'isHomeTeam') ===  true);
        const periodScoresAway = _.filter(this.match.scoringEvents, (se) => _.get(se, 'period') === _.get(periodsList[i], 'period') && _.get(se, 'isHomeTeam') ===  false);
        let totalPeriodScoresHome = 0;
        let totalPeriodScoresAway = 0;
        for (let score of periodScoresHome) {
          totalPeriodScoresHome += _.get(score, 'value', 0);
        }
        for (let score of periodScoresAway) {
          totalPeriodScoresAway += _.get(score, 'value', 0);
        }
        if (tempHeader === header) {
          homeRow[tempIndex] += totalPeriodScoresHome;
          awayRow[tempIndex] += totalPeriodScoresAway;
        } else {
          homeRow.push(totalPeriodScoresHome);
          awayRow.push(totalPeriodScoresAway);
          tempIndex = homeRow.length - 1;
        }
        tempHeader = header;
      }
      let totalScoresHome = 0;
      let totalScoresAway = 0;
      for (let i = 0; i < homeRow.length; i++) {
        totalScoresHome += homeRow[i];
        totalScoresAway += awayRow[i];
      }
      homeRow.push(totalScoresHome);
      awayRow.push(totalScoresAway);
      rows.push(homeRow);
      rows.push(awayRow);
      headers.push('T');
      console.log({
        periodsList,
        headers,
        rows,
        display: _.get(this.match, 'display.perPeriodScore', false),
      });
      return {
        periodsList,
        headers,
        rows,
        display: _.get(this.match, 'display.perPeriodScore', false),
        totalScores: {
          home: totalScoresHome,
          away: totalScoresAway
        },
      };
    },
    perSetScoreData() {
      const match = this.$store.getters["match/matchDetails"];
      const setScores = this.$store.getters["match/setScores"];
      if (!match || !setScores || !match.currentSetId) return {};
      const setsList = _.uniq(setScores.map(set => set.setId));
      const headers = [];
      const rows = [];
      const homeRow = [];
      const awayRow = [];
      let tempHeader = '';
      let tempIndex = 0;
      for (let i = 0; i < setsList.length; i++) {
        let header = setsList[i];

        const foundSet = setScores.find(set => set.setId === setsList[i]) || { scoringEvents: [], scores: [] };
        const { scoringEvents, manual, scores } = foundSet;

        if (i === setsList.length - 1) {
          const periodScoresHome = scoringEvents.filter(event => event.isHomeTeam === true);
          const periodScoresAway = scoringEvents.filter(event => event.isHomeTeam !== true);
          let totalPeriodScoresHome = 0;
          let totalPeriodScoresAway = 0;
          for (let score of periodScoresHome) {
            totalPeriodScoresHome += _.get(score, 'value', 0);
          }
          for (let score of periodScoresAway) {
            totalPeriodScoresAway += _.get(score, 'value', 0);
          }
          if (totalPeriodScoresHome === 0 && totalPeriodScoresAway === 0) continue;
        }

        if (tempHeader !== header) {
          headers.push(header);
        }

        if (!manual) {
          const periodScoresHome = scoringEvents.filter(event => event.isHomeTeam === true);
          const periodScoresAway = scoringEvents.filter(event => event.isHomeTeam !== true);
          let totalPeriodScoresHome = 0;
          let totalPeriodScoresAway = 0;
          for (let score of periodScoresHome) {
            totalPeriodScoresHome += _.get(score, 'value', 0);
          }
          for (let score of periodScoresAway) {
            totalPeriodScoresAway += _.get(score, 'value', 0);
          }
          if (tempHeader === header) {
            homeRow[tempIndex] += totalPeriodScoresHome;
            awayRow[tempIndex] += totalPeriodScoresAway;
          } else {
            homeRow.push(totalPeriodScoresHome);
            awayRow.push(totalPeriodScoresAway);
            tempIndex = homeRow.length - 1;
          }
        } else {
          const { homeTeam, awayTeam } = scores;
          homeRow.push(homeTeam);
          awayRow.push(awayTeam);
          tempIndex = homeRow.length - 1;
        }


        tempHeader = header;
      }
      const homeMatchScore = this.homeScore;
      const awayMatchScore = this.awayScore;
      homeRow.push(homeMatchScore);
      awayRow.push(awayMatchScore);
      rows.push(homeRow);
      rows.push(awayRow);
      headers.push('T');
      return {
        setsList,
        headers,
        rows,
        display: _.get(match, 'display.perPeriodScore', true),
      };
    },
    generatedPlayerStats() {
      return this.getPlayerStats();
    },
    isMultiSport() {
      const headers = _.get(this.generatedPlayerStats, 'headers', []);
      const rows = _.get(this.generatedPlayerStats, 'rows', []);
      if (headers.length > 0 && rows.length > 0) {
        return true;
      }
      return false;
    },
    // Game status simulated if timer is running and ended, will show the next period
    // If timer is running return regular gameStatus, current period
    gameStatusSimulated() {
      if (this.liveTiming) {
        if (_.get(this.timerData, 'ended') === true) {
          const currentPeriod = this.gameStatus;
          const statusObject = this.getStatusObjectFromStatusName(currentPeriod);
          // const periodTypeStatuses = _.filter(this.statusEquivalence, (se) => _.get(se, 'periodType') === _.get(statusObject, 'periodType'));
          // const nextStatusObject = _.find(periodTypeStatuses, (pts) => pts.period === (statusObject.period + 1));
          const periods = _.filter(this.statusEquivalence, se => _.get(se, 'period'));
          const currentObj = _.find(periods, p => _.get(p, 'value') === currentPeriod);
          const index = _.findIndex(periods, p => _.get(p, 'value') === currentPeriod);
          const nextStatusObject = _.nth(periods, index + 1);
          const value = _.get(nextStatusObject, 'value', undefined);
          if (!currentObj || value === 'final') {
            return this.gameStatus;
          }
          return nextStatusObject ? nextStatusObject.value : '';
        }
      }
      return this.gameStatus === 'pre-game' ? 'Vs.' : this.gameStatus;
    },
    lastPeriodEnd() {
      if (this.liveTiming) {
        if (_.get(this.timerData, 'ended') === true) {
          const currentPeriod = this.gameStatus;
          const statusObject = this.getStatusObjectFromStatusName(currentPeriod);
          const index = _.findIndex(this.statusEquivalence, m => _.get(m, 'value') === _.get(statusObject, 'value'));
          const nextPeriod = _.nth(this.statusEquivalence, index + 1);
          // const periodTypeStatuses = _.filter(this.statusEquivalence, (se) => _.get(se, 'periodType') === _.get(statusObject, 'periodType'));
          // const nextStatusObject = _.find(periodTypeStatuses, (pts) => pts.period === (statusObject.period + 1));
          const value = _.get(nextPeriod, 'value', undefined);
          return value === 'final';
        }
      }
      return false;
    },
    ...mapGetters('national', ['timezone']),
    timerNotRequired() {
      const { match } = this;
      return match && ['pre-game', 'final'].includes(match.status)
    },
  },
};
</script>
<style scoped lang="scss">

/* ion-toolbar {
  --border-width: 0 !important;
} */

.penalty-rows {
  gap: 0.5rem;
  margin-bottom: 1.5rem;
}

.pen-container {
  display: grid;
  grid-template-columns: repeat(1fr, 1fr);
  gap: 0.5rem;
}

.pen-column {
  display: flex;
  gap: 0.25rem;
  border: 1px solid #a3a3a3;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
}
.penalty {
  width: 0.75em;
  height: 0.75rem;
  background: #E6E6E6;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.won {
    background: #1ee000;
  }
  &.loss {
    background: #FF0000 !important;
  }
}

.notify-me-button {
  margin-top: -2rem;
  display: flex;
  justify-content: center;
  z-index: 100;
}

.match-detail-row {
  padding: 0 1.5rem;
  padding-bottom: 1rem;
}

.notify-me {
  min-width: 10rem;
  background: #F64C4C;
  box-shadow: 0 4px 12px 0 #F64C4C;
  height: 3rem;
  border-radius: 24px;
  padding: 0.5 1.5rem;
}

::v-deep.match-content {
  display: grid;
  justify-content: center;
  position: relative;
  max-height: 80vh;
  overflow: scroll;
  z-index: 100;

  @media (min-width: 768px) {
    min-width: 728px;
  }

  @media (max-width: 768px) {
    // min-width: 1024px;
    padding: 0.5rem !important;
  }


  &:after {
    content: "";
    position: absolute;
    left: 50%;
    top: 10vh;
    width: 2px;
    height: 200vh;
    background-color: rgba(235, 235, 235, 0.2);
    z-index: -1;
  }
}

.chip {
  font-size: .75rem;
  color: #a9a9a9 !important;
  font-family: 'Cairo';
  &.active {
    background: var(--highlight-color);
    color: #000 !important;
    // color: var(--ion-color-primary);
    font-family: 'Cairo';
  }

  &.selectable {
    cursor: pointer;
    color: #a9a9a9;
    background: #1E1F22;
  }
}

.period-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  background: $background !important;
}

.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

.custom-segment {
  border: none;
  padding-top: 0px;
  /* background: white; */
  display: flex;
  justify-content: center;
  border-radius: 0px;
  /* border-bottom: 1px solid rgba(177, 177, 177, 0.3); */
}

.custom-segment ion-label {
  margin-bottom: 0;
}

.custom-segment::before {
  border-left: none;
}

.custom-segment .in-segment {
  padding: 0.5rem 0;
  // color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, .7);
  font-size: 1rem;
}

.custom-segment .segment-button-checked {
  padding: 0.5rem 0;
  // color: rgb(234 68 68);
  color: white;
  border-radius: 0;
  margin-bottom: 0;
  color: $highlight;
  background-color: rgba($primary, .7);
  font-size: 1rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}

.custom-card {
  margin-top: 0;
  margin-bottom: 0;
  margin-right: 0px;
  margin-left: 0px;
  padding: 0px;
  padding-bottom: 1.5rem;
  box-shadow: none;
  -webkit-box-shadow: none;
  /* border-radius: 0 0 1rem 1rem; */
  border: 0;
  /* background: #232528; */
  background: transparent;
  color: white;
  z-index: 5;
}

.custom-card .card-content-ios {
  padding: 0;
  padding-top: 5px;
}

ion-content {
  --background: transparent;
  /* box-shadow: inset 0 0 0 1000px rgb(0 0 0 / 70%);
  -webkit-box-shadow: inset 0 0 0 1000px rgb(0 0 0 / 70%); */
  --background: $background !important;
  --padding-top: 0rem;
  --padding-start: 0.5rem;
  --padding-end: 0.5rem;
  --padding-bottom: 1rem;
}

ion-content::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: rgba(0,0,0,0.3);
}

ion-content::-webkit-scrollbar
{
  width: .35rem;
  background-color: rgba(0,0,0,0.3);
}

ion-content::-webkit-scrollbar-thumb
{
  background-color: #888;
}


ion-content::before {
  box-shadow: inset 0 0 2000px rgba(35, 37, 40, .2);
   -webkit-box-shadow: inset 0 0 2000px rgba(35, 37, 40, .2);
  filter: blur(1rem);
  filter: blur(2rem);
}

ion-button {
  --color: white;
}

.feed-modal {
  --height: 100% !important;
  background: white;
  align-items: flex-end;
}
.feed-modal .modal-wrapper {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.teamlist-container {
  min-height: 50vh !important;
}

.empty-container {
  height: 60vh;
  display: black;
  justify-content: center;
  align-items: center;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.team-name {
  margin-top: 1rem;
  font-size: 0.8rem;
  transition: all 0.25s ease-in-out;
}

.card-content-md {
  padding: 0;
}

.overlay {
  padding: 0rem;
  position: relative;

  .match-background {
    // position: relative;
    width: 100%;
    height: auto;
    overflow: hidden;
    z-index: 1;

    img {
      position: absolute;
      object-fit: cover;
      z-index: 1;
      width: 100%;
      height: 100%;
      border-bottom-left-radius: 36px;
      border-bottom-right-radius: 36px;
    }
  }

  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7); /* Dark overlay */
    z-index: 2;
  }
}

ion-toolbar {
  --border-width: 0 !important;
  --background: transparent;
  --color: white;
}

.in-progress-box {
  display: flex;
  flex-direction: column;

  gap: 0.5rem;
  .period {
    border-radius: 24px;
    border: 1px solid white;
    display: flex;
    padding: 0.5rem 1rem;
    .text {
      font-size: 0.8rem;
      text-transform: uppercase;
      // padding-bottom: 0.1rem;
      color: white;
    }
  }

  .timer {
    display: flex;
    // gap: 0.25rem;
    align-items: center;
    // gap: 0.5rem;
    // border-bottom: 1px solid #3c3c3c;
    padding: 0 1rem;
    width: 100%;
    justify-content: center;
    .text {
      font-size: 1.3rem;
      color: white;
    }
  }

}

.badgeHalf{
  display: flex;
  font-size: 1.3rem;
  padding-top: 1rem;
}
.badgeQuarter{
  display: flex;
  font-size: 1.3rem;
  padding-top: 0rem;
  // padding-bottom: 0.1rem;
  padding-left: 0.7rem;
  padding-right: 0.7rem;
  background: none;
}
.timerDot{
  margin-left: -1rem;
  margin-right: 0.5rem;
}
.quarterStatus{
  margin-top: 0;
  // margin-bottom: 0.2rem;
}

.addTimePlus {
  margin-left: 0.2rem;
  margin-top: 0.06rem;
}

@media only screen and (max-width: 600px) {
  .in-progress-box {
    .period {
      .text {
        font-size: 0.6rem;
      }
    }

    .timer {
      .text {
        font-size: 0.8rem;
      }
    }

    .timer {
      .text {
        font-size: 0.8rem;
      }
    }

  }
}

.per-period-section {
  margin-top: 5px;
}

/* Report Download Button Styling */
.report-download-btn {
  --background: #28a745 !important;
  --background-hover: #218838 !important;
  --color: white !important;
  --border-radius: 8px;
  --padding-start: 16px;
  --padding-end: 16px;
  --padding-top: 8px;
  --padding-bottom: 8px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  animation: pulse-glow 2s infinite;
  transition: all 0.3s ease;
}

.report-download-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(40, 167, 69, 0.4);
}

@keyframes pulse-glow {
  0% {
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  }
  50% {
    box-shadow: 0 4px 16px rgba(40, 167, 69, 0.5);
  }
  100% {
    box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
  }
}

</style>
